const FontFaceObserver = require('fontfaceobserver');

const ssGlyphish = document.createElement('link');
ssGlyphish.rel = 'stylesheet';
ssGlyphish.href = '/fonts/ss-glyphish-outlined.css';
ssGlyphish.onload = function () {
  document.body.classList.add('loaded-glyphish-icons');
};
document.body.appendChild(ssGlyphish);

const fontscom = document.createElement('script');
fontscom.src = '//fast.fonts.net/jsapi/03267ca4-bfab-4486-af48-9c700a1253f8.js';
fontscom.async = true;
fontscom.onload = function () {
  const SSTW05 = new FontFaceObserver('SST Japanese W05');
  // const SSTW50 = new FontFaceObserver('SST Japanese W50');
  const DINW01 = new FontFaceObserver('DIN 1451 W01');

  Promise.all([
    SSTW05.load(),
    // SSTW50.load(),
    DINW01.load()
  ]).then(function (value) {
    // console.log('sucess',value);
    document.body.classList.add('loaded-fontscom');
  },function(reason){
    // console.log('error',reason);
    document.body.classList.add('loaded-fontscom');
  });
};
document.body.appendChild(fontscom);
